(function () {
  'use strict';

  angular.module(moduleConfig.applicationModuleName).factory('qualtricsService', ['$rootScope', 'uteLocale', 'env', function ($rootScope, uteLocale, env) {
    var service = {};
    var agentInfo = {};
    var lang = 'EN';
    var langUpperCase = '';

    function getFlashVersion(){
      try {
        try {
          var axo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.6');
          try {
            axo.AllowScriptAccess = 'always';
          }
          catch(e) {
            return '6,0,0';
          }
        }
      catch(e) {}
        return new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version').replace(/\D+/g, ',').match(/^,?(.+),?$/)[1];
        // other browsers
    	} catch(e) {
    	try {
    	  if(navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin){
    		    return (navigator.plugins["Shockwave Flash 2.0"] || navigator.plugins["Shockwave Flash"]).description.replace(/\D+/g, ",").match(/^,?(.+),?$/)[1];
    	  }
    	} catch(e) {}
      }
      return '0,0,0';
    }

    service.openAgentFeedback = function(){
      lang = uteLocale.language;
      if(lang) {
        langUpperCase = lang.toUpperCase();
      }
      agentInfo = $rootScope.userInfo.cfaInfo;
      var sourceURL = window.location.protocol + '//' + window.location.host + window.location.pathname;
      var encodedURL=encodeURIComponent(sourceURL);
      var browser = _ute.device.name;
      var browserVersion = _ute.device.browserVersion;
      var OSName="Unknown OS";
      if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
      if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
      if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
      if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

      if (agentInfo) {
        var userName=agentInfo.agentName;
        var userDealerCode = agentInfo.dealerCode;
        var userIPAddress = agentInfo.ipAddress;
        var encodedUName=encodeURIComponent(userName);
        var dispUserName="UserName="+encodedUName;
        var userId=agentInfo.userID;
        var encodedUId=encodeURIComponent(userId);
        var flashVersion = getFlashVersion().split(',').shift();
        var browserDispVal=encodeURIComponent(browser+" "+browserVersion);
        var jsessionId=agentInfo.jSessionID;

        //array of params Qualtrics
        var qualtricsParms= new Array();
        qualtricsParms["UserID"] = encodedUId;
        qualtricsParms["DealerCode"] = userDealerCode;
        qualtricsParms["IPAddress"] = userIPAddress;
        qualtricsParms["browser"] = browserDispVal;
        qualtricsParms["browser_name"] = browser;
        qualtricsParms["browser_version"] = browserVersion;
        qualtricsParms["os"] = OSName;
        qualtricsParms["url"] = encodedURL;
        qualtricsParms["flash"] = flashVersion;
        qualtricsParms["sessionid"] = jsessionId;
        qualtricsParms["Q_Language"] = langUpperCase;
        var cppString="";
        for(var paramKey in qualtricsParms) {
          cppString += "&" + paramKey + "=" + qualtricsParms[paramKey];
        }
        var fullURL=env.agentFeedbackSSP+"?"+dispUserName+cppString;
        window.open(fullURL);
      }
      else{
        window.open(env.agentFeedbackSSP);
      }
    }

    return service;

  }]);
})();
